import { mgPlatformDiscordIcon } from './discord'
export const socialIcons = [mgPlatformDiscordIcon]
